import {useWbAgentClient} from '@wandb/weave/lib/WbAgent/useWbAgentClient';
import {useCallback} from 'react';

import {useNavContext} from '../components/NavContextProvider';

export const useSubmitAgentFeedback = (): ((
  turnId: string,
  feedbackIsPositive: boolean | null,
  feedbackReasoning?: string | null,
  shareTurnData?: boolean
) => Promise<void>) => {
  const {params} = useNavContext();
  const client = useWbAgentClient(params.entityName, params.projectName);

  return useCallback(
    async (
      turnId: string,
      feedbackIsPositive: boolean | null,
      feedbackReasoning?: string | null,
      shareTurnData?: boolean
    ) => {
      if (!client || !turnId) {
        return;
      }
      try {
        await client.post(`/turns/${turnId}/feedback` as '/turns', {
          feedback_is_positive: feedbackIsPositive,
          feedback_reasoning: feedbackReasoning || null,
          share_turn_data_with_wandb: shareTurnData ?? false,
        });
      } catch {
        // Best-effort — local state already updated
      }
    },
    [client]
  );
};
